import { useTranslation } from "react-i18next";
import { CLAIM_STATUS_LABEL_KEY, CLAIM_STATUS_TONE } from "../constants/claimConstants";

/**
 * Claim status pill. The tone map lives in claimConstants so the badge, the
 * filters and any future approver screen agree on what each status looks like;
 * the colours themselves are the status tokens in styles/globals.css.
 */
export function ClaimStatusBadge({ status, className = "" }) {
  const { t } = useTranslation();
  const tone = CLAIM_STATUS_TONE[status] || "archived";
  const labelKey = CLAIM_STATUS_LABEL_KEY[status];

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold whitespace-nowrap ${className}`}
      style={{
        backgroundColor: `var(--status-${tone}-bg)`,
        color: `var(--status-${tone}-fg)`,
      }}
    >
      <span
        className="h-1.5 w-1.5 rounded-full"
        style={{ backgroundColor: `var(--status-${tone}-dot)` }}
      />
      {labelKey ? t(labelKey) : status}
    </span>
  );
}

export default ClaimStatusBadge;
